import React, { useState } from 'react';
import ImageLogo from './components/Image';
import { useAuth } from './AuthContext';
import { useNavigate } from "react-router-dom";

const Header = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const handleSignOut = () => {
    try {
      navigate('/dashboard');
    } catch (error) {
    }
  };

  const closeMobileMenu = () => {
    setIsMenuOpen(false);
    setOpenSubmenu(null);
  };

  const toggleMobileMenu = () => {
    setIsMenuOpen((open) => !open);
    setOpenSubmenu(null);
  };

  // On mobile, tapping a submenu label toggles it open/closed instead of
  // relying on :hover (which doesn't exist on touch devices). On desktop
  // the CSS :hover rule still opens it, so this only needs to matter when
  // the mobile nav is showing.
  const toggleSubmenu = (key) => (e) => {
    if (isMenuOpen) {
      e.preventDefault();
      setOpenSubmenu((current) => (current === key ? null : key));
    }
  };

  return (
    <header>
      <button
        className="menu-toggle"
        onClick={toggleMobileMenu}
        aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isMenuOpen}
      >
        ☰
      </button>

      <div className={`header ${isMenuOpen ? 'show' : ''}`}>
        <ImageLogo id="logo" src="/virsatbluelogo.png" alt="Virsat Logo" width="150" height="auto" />

        <nav>
          <ul>
            <li><a href="/" onClick={closeMobileMenu}>Home</a></li>

            <li className={`submenu ${openSubmenu === 'training' ? 'open-mobile' : ''}`}>
              <a href="#" onClick={toggleSubmenu('training')}>
                Training Courses
                <span className="submenu-caret">▾</span>
              </a>
              <ul className={`submenu-list ${openSubmenu === 'training' ? 'open' : ''}`}>
                <li><a href="/fundamentals" onClick={closeMobileMenu}>Training Fundamentals</a></li>
                <li><a href="/life-saving" onClick={closeMobileMenu}>Life-Saving Rules</a></li>
                <li><a href="/driving-pro" onClick={closeMobileMenu}>Driving Safety</a></li>
                <li><a href="/module-videos" onClick={closeMobileMenu}>Sample Videos</a></li>
              </ul>
            </li>

            <li><a href="/pricing" onClick={closeMobileMenu}>Prices</a></li>

            <li><a href="/pclicense" onClick={closeMobileMenu}>Purchase</a></li>

            <li><a href="/gameplay" onClick={closeMobileMenu}>Play Now</a></li>

            <li className={`submenu ${openSubmenu === 'about' ? 'open-mobile' : ''}`}>
              <a href="#" onClick={toggleSubmenu('about')}>
                About us
                <span className="submenu-caret">▾</span>
              </a>
              <ul className={`submenu-list ${openSubmenu === 'about' ? 'open' : ''}`}>
                <li><a href="/about" onClick={closeMobileMenu}>About Virsat</a></li>
                <li><a href="/faq" onClick={closeMobileMenu}>FAQs</a></li>
                <li><a href="/contact" onClick={closeMobileMenu}>Contact</a></li>
              </ul>
            </li>

            <li className='auth-buttons' style={{ display: 'flex', gap: '10px' }}>
              {user ? (
                <>
                  {user.role === 'ADMIN' && (
                    <button
                      className="header-button"
                      style={{ backgroundColor: '#214DA0', color: '#fff', fontWeight: 'bold' }}
                      onClick={() => { navigate('/admin'); closeMobileMenu(); }}
                    >
                      Admin Panel
                    </button>
                  )}
                  <button className="header-button" onClick={() => { navigate('/dashboard'); closeMobileMenu(); }}>Dashboard</button>
                </>
              ) : (
                <button className="header-button" onClick={() => { navigate('/login'); closeMobileMenu(); }}>Business Login</button>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
